export const customerRelationshipOptions = {
    label: {
        isBillTo: "Is a bill-to customer",
        isShipTo: "Is a ship-to customer",
        isNotBillTo: "Is not a bill-to customer",
        isNotShipTo: "Is not a ship-to customer",
    },
    value: {
        isBillTo: "billTo",
        isShipTo: "shipTo",
        isNotBillTo: "notBillTo",
        isNotShipTo: "notShipTo",
    },
};

export const customerExposuresOptions = {
    label: {
        missingCertificates: "Missing certificates",
        invalidCertificates: "Invalid certificates",
        expiredCertificates: "Expired certificates",
    },
    value: {
        missingCertificates: "EXPOSURE: MISSING CERT",
        invalidCertificates: "EXPOSURE: INVALID CERT",
        expiredCertificates: "EXPOSURE: EXPIRED CERT",
    },
};

/**
 * Splits newline-separated identifier string into array, trims each value, filters empty, and maps with processor.
 * @param {string | undefined} ids - Newline-separated string of identifiers
 * @param {function} [processor=v => v] - Optional function to transform each value
 * @returns {Array} Processed array of values
 */
export const processIdentifiers = (ids, processor = v => v) => {
    if (!ids?.length) return [];
    return ids
        .split("\n")
        .map(value => value.trim())
        .filter(value => value !== "")
        .map(processor);
};

export function getCustomerRelationShip(relationShip, key) {
    const oppositeKey =
        key === customerRelationshipOptions.value.isBillTo
            ? customerRelationshipOptions.value.isNotBillTo
            : customerRelationshipOptions.value.isNotShipTo;

    // If both positive and negative relationships exist, return null
    if (relationShip.includes(key) && relationShip.includes(oppositeKey)) {
        return null;
    }

    // Return true if key exists, false if opposite exists, null if neither exists
    return relationShip.includes(key) ? true : relationShip.includes(oppositeKey) ? false : null;
}
